import { ReactNode } from 'react'
import styled from 'styled-components'

const prority_styles = {
  1: {
    backgroundColor: 'var(--brandblue-main)',
    color: '#fff',
    boxShadow:
      '0.5em 0 0 var(--brandblue-main), -0.5em 0 0 var(--brandblue-main)',
  },
  2: {
    backgroundColor: 'var(--petrol-dark-1)',
    color: '#fff',
    boxShadow:
    '0.5em 0 0 var(--petrol-dark-1), -0.5em 0 0 var(--petrol-dark-1)',
  },
  3: {
    backgroundColor: 'var(--red-dark-1)',
    color: '#fff',
    boxShadow:
    '0.5em 0 0 var(--red-dark-1), -0.5em 0 0 var(--red-dark-1)',
  },
  4: {
    backgroundColor: 'var(--beige-main)',
    color: '#fff',
    boxShadow:
    '0.5em 0 0 var(--beige-main), -0.5em 0 0 var(--beige-main)',
  },
}

export const AnnotationTextMarker = ({
  children,
  prio = 1,
  exact = false,
}: {
  children: ReactNode
  prio?: 1 | 2 | 3 | 4
  exact?: boolean
}) => {
  return (
    <AnnotationTextMarkerContainer
      style={{
        fontStyle: exact ? 'normal' : 'normal',
        color: prority_styles[prio].color,
        backgroundColor: prority_styles[prio].backgroundColor,
        boxShadow: prority_styles[prio].boxShadow,
        padding:exact?"2px 0 3px 0": "2px 0px 3px 0"
        // padding:exact?"2px 0 3px 0": "2px 4px 3px 0"
      }}
    >
      {children}
    </AnnotationTextMarkerContainer>
  )
}
const AnnotationTextMarkerContainer = styled.span`
  /* padding: 0px 10px 0px 10px; */
  display: inline;
  
  font-size: 0.95em;
  position: relative;
  font-family: var(--font-sans-serif);
  /* box-shadow: 1em 0 0 #FFAA3B,-1em 0 0 #FFAA3B; */
  margin: 0 0.5em;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
`
